// src/i18n/locales/de/productSettings.ts

export const productSettings = {
  // Page Header
  title: 'Produkt-Einstellungen',
  subtitle: 'Affiliate-System und Einkaufslistenmodus verwalten',

  // Affiliate Toggle Section
  affiliateSystem: 'Affiliate-System',
  masterSwitch: 'Hauptschalter',
  
  // Status Messages
  status: {
    enabled: 'Smart Shopping Aktiviert',
    disabled: 'Einfacher Listen-Modus Aktiv',
    enabledDescription: 'VIP-Benutzer können auf den Smart Shopping-Modus mit echten Produktkarten, Preisen und Affiliate-Links zugreifen.',
    disabledDescription: 'Alle Benutzer sehen den einfachen Listen-Modus nur mit geschätzten Preisen. Smart Shopping ist deaktiviert.',
  },

  // Toggle Labels
  toggleLabel: {
    on: 'Aktiviert',
    off: 'Deaktiviert',
  },

  // Info Card
  infoCard: {
    title: 'Wie funktioniert das?',
    simpleMode: {
      title: 'Einfacher Listen-Modus',
      description: 'Zeigt nur Produktnamen und Mengen mit geschätzten Preisen. Keine Supermarktnamen oder Produktbilder.',
    },
    smartMode: {
      title: 'Smart Shopping-Modus (VIP)',
      description: 'Zeigt echte Produktkarten von Migros/Coop mit genauen Preisen, Bildern und "Jetzt kaufen"-Buttons mit Affiliate-Links.',
    },
    note: 'Wenn der Hauptschalter AUS ist, sind alle Benutzer (BASIC + VIP) im einfachen Listen-Modus gesperrt.',
  },

  // Impact Notice
  impactNotice: {
    title: 'Was passiert, wenn Sie dies ändern?',
    enable: 'VIP-Benutzer können zwischen einfachem Listen-Modus und Smart Shopping-Modus wechseln.',
    disable: 'Alle Benutzer werden auf den einfachen Listen-Modus umgestellt. VIP-Umschalter wird gesperrt.',
  },

  // Stats Cards
  stats: {
    vipUsers: 'VIP-Benutzer',
    basicUsers: 'BASIC-Benutzer',
    totalUsers: 'Gesamtbenutzer',
    affiliateClicks: 'Affiliate-Klicks',
    thisMonth: 'Diesen Monat',
  },

  // Actions
  save: 'Änderungen speichern',
  cancel: 'Abbrechen',
  confirm: 'Bestätigen',

  // Confirmation Modal
  confirmModal: {
    enableTitle: 'Affiliate-System aktivieren?',
    disableTitle: 'Affiliate-System deaktivieren?',
    enableMessage: 'VIP-Benutzer erhalten Zugriff auf den Smart Shopping-Modus mit Produktkarten und Affiliate-Links.',
    disableMessage: 'Alle Benutzer werden auf den einfachen Listen-Modus umgestellt. Dies wirkt sich auf die VIP-Benutzererfahrung aus.',
    confirm: 'Ja, fortfahren',
    cancel: 'Abbrechen',
  },

  // Toast Messages
  toast: {
    enabled: 'Affiliate-System aktiviert - VIP-Benutzer können jetzt auf den Smart Shopping-Modus zugreifen',
    disabled: 'Affiliate-System deaktiviert - Alle Benutzer auf einfachen Listen-Modus umgestellt',
    error: 'Fehler beim Aktualisieren des Affiliate-Systems',
  },
};